function rangeSliderReduser(state = {
    range_amount:3000,
    range_amount_percent:null,
    }, action) {
      switch (action.type) {
        case 'SET_RANGE_AMOUNT_DATA':
          return {
            ...state,
            range_amount: action.range_amount,
            range_amount_percent:action.range_amount_percent,
          };
        default:
          return state;
      }
    } // Редюсер обр. слайдера.
    
    
    export default rangeSliderReduser
    
    
    


// WEBPACK FOOTER //
// src/reducers/rangeSliderReduser.js